import { ref, useTemplateRef } from 'vue'
import type MemberRegistrationModal from '@/components/memberManagement/MemberRegistrationModal.vue'
import type MemberRegistrationSuccessDialog from '@/components/memberManagement/MemberRegistrationSuccessDialog.vue'
import type MemberDeleteConfirmDialog from '@/components/memberManagement/MemberDeleteConfirmDialog.vue'
import { setLoadingView } from '@/features/miiaFw/utils/miiaFwUtils'
import { useMemberManagement } from './useMemberManagement'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { ERROR_CODES } from '@/constants/error/errorCode'

export const useMemberPartsCombination = () => {
  const memberRegistrationModal =
    useTemplateRef<InstanceType<typeof MemberRegistrationModal>>('memberRegistrationModal')
  const memberRegistrationSuccessDialog = useTemplateRef<
    InstanceType<typeof MemberRegistrationSuccessDialog>
  >('memberRegistrationSuccessDialog')
  const memberDeleteConfirmDialog = useTemplateRef<InstanceType<typeof MemberDeleteConfirmDialog>>(
    'memberDeleteConfirmDialog'
  )
  const { fetchUserInfoForOrgAdmin } = useMemberManagement()

  const checkedItems = ref<string[]>([])

  /**
   * 新規作成ボタン押下時に呼ばれる
   */
  const createUser = async () => {
    // 新規ユーザー登録モーダル画面を表示する
    const result = await memberRegistrationModal.value?.openModal()
    if (!result) {
      return
    }
    // 新規登録成功ダイアログを表示する
    await memberRegistrationSuccessDialog.value?.openDialog()
    // 新規登録成功後に、団体管理者用のユーザー情報を再取得する
    try {
      setLoadingView(true)
      await fetchUserInfoForOrgAdmin()
    } catch (e) {
      throw GlobalError.chainError(e, ERROR_CODES._811301_FETCH_USER_ERROR)
    } finally {
      setLoadingView(false)
    }
  }

  /**
   * 削除ボタン押下時に呼ばれる
   */
  const deleteUser = async () => {
    // ユーザー削除確認ダイアログ画面を表示する
    const result = await memberDeleteConfirmDialog.value?.openDialog()
    if (!result) {
      return
    }
    // ユーザー削除処理は成功しているので、チェックをリセットする
    checkedItems.value = []
    // ユーザー削除処理成功後に、団体管理者用のユーザー情報を再取得する
    try {
      setLoadingView(true)
      await fetchUserInfoForOrgAdmin()
    } catch (e) {
      throw GlobalError.chainError(e, ERROR_CODES._811301_FETCH_USER_ERROR)
    } finally {
      setLoadingView(false)
    }
  }
  return { checkedItems, createUser, deleteUser }
}
